<template>
  <div class="column is-12 card-block recommend-container"
       :class="{
          'recommend-container_open' : showRecommended,
          'recommend-container_close' : !showRecommended,
          'recommend-container_close-noAudio' : !isListen
       }"
       :style="{
          maxWidth: widthMax + 'px',
          bottom: attachBottom + 'px'
       }"
        @click="toggleRecommended"
       role="complementary"
       aria-label="recommendation menu"
  >
    <div class="recommend-content no-print">
      <button class="footer-title has-text-weight-bold recommend-content_btn"
              role="button"
              aria-labelledby="recommendedation button toggle"
              :aria-pressed="showRecommended"
      >
        {{ $t('story-footer.more-stories') }}
        <i class="fal recommend-arrow"
           :class="{
              'fa-chevron-down' : !showRecommended,
              'fa-chevron-up' : showRecommended
            }"
        />
      </button>
      <button v-if="showRecommended"
              class="recommend-content_btn recommend-content_closeBtn"
              role="button"
              aria-labelledby="recommendedation button close"
              :aria-pressed="showRecommended">
        <i class="far fa-times" />
      </button>
      <!-- story card -->
      <div v-if="showRecommended">
        <!-- Check for recommended -->
        <div v-if="getProjects.length > 0"
             class="card-row is-flex recommend-content_cardContainer">
          <div v-for="link in getProjects"
               :key="link.title"
               aria-labelledby="recommended articles"
          >
            <project-card
                :projectID="link.id"
            />
          </div>
        </div>
        <!-- Display empty -->
        <div v-else aria-labelledby="no recommended articles">
          <p>{{errorMessage()}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n'
import ProjectCard from '@/components/Cards/ProjectCards'
export default {
  data () {
    return {
      showRecommended: false,
      attachBottom: -15
    }
  },
  components: {
    ProjectCard
  },
  props: {
    getProjects: {
      type: Array,
      required: true
    },
    widthMax: {
      type: Number,
      default: 1200
    },
    isListen: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleRecommended () {
      this.showRecommended = !this.showRecommended
    },
    errorMessage () {
      return this.isVideo ? i18n.t('recommended.noVideo') : i18n.t('recommended.noArticles')
    },
    handleScroll () {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100) {
        this.showRecommended = true
        this.attachBottom = 30
      } else {
        this.showRecommended = false
        this.attachBottom = -15
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.recommend {
  &-container {
    position: fixed;
    z-index: 10;
    cursor: pointer;
    left: 50%;
    transform: translateX(-50%);
    &_close {
      opacity: .8;
    }
    &_open {
      opacity: 1;
      width: 100%;
    }
  }
  &-content {
    padding: 1rem;
    background: #F8F8F8;
    border-radius: 12px;
    margin: 0 3rem;
    box-shadow: 0px 5px 17px rgba(135, 135, 135, 0.5);
    &_btn{
      border: none;
      background: transparent;
      cursor: pointer;
    }
    &_closeBtn{
      float: right;
      color: #7A2A90;
    }
    &_cardContainer {
      overflow: auto;
    }
  }
  &-arrow {
    color: #7A2A90;
    width: 11px;
    height: 6px;
    padding-left: .5rem;
  }
}

.footer-title {
  font-size: 0.6rem;
  color:#7A2A90;
  text-transform: uppercase;
}

@media screen and (max-width: 1500px){
  .recommend {
    &-container {
      &_open {
        width: 100%;
      }
      &_close {
        width: calc(1200px * .75) !important;
        bottom: -15px;
        opacity: .8;
        &-noAudio {
          width: 100% !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px){
  .recommend {
    &-container {
      left: 0;
      transform: none;
      &_open {
        width: 100%;
        opacity: 1;
      }
      &_close {
        bottom: 30px !important;
        opacity: .8;
        width: calc(1200px * .15) !important;
        &-noAudio {
          width: 100% !important;
        }
      }
    }
    &-content {
      margin: 0;
    }
  }
}

@media screen and (max-width: 480px) {
  .recommend {
    &-container {
      left: 0;
      transform: none;
      &_open {
        bottom: 20px !important;
        width: 100%;
        opacity: 1;
      }
      &_close {
        bottom: 18px !important;
        opacity: .8;
        width: auto !important;
      }
    }
    &-content {
      margin: 0;
    }
  }
}
</style>
